import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
  Stack,
  InputAdornment,
  IconButton,
  Radio,
  FormControlLabel,
  RadioGroup,
  Select,
  MenuItem,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useDispatch, useSelector } from 'react-redux';
import { previousStep } from '../../../../../slice/multiStepSlice';
import { useTMutation } from '../../../../../utils/useTMutation';
import { useNavigate } from 'react-router-dom';
import showToast from '../../../../../components/Hot-Toast/showToast';

function QuestionForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { values } = useSelector((state) => state?.multiStep);

  const [mcqs, setMcqs] = useState([]);
  const [selectedMcqIndex, setSelectedMcqIndex] = useState(null);
  const [question, setQuestion] = useState('');
  const [choices, setChoices] = useState(['', '']);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [assessmentName, setAssessmentName] = useState(values?.assessmentName || '');
  const [specialityName, setSpecialtyName] = useState(values?.SPECIALTY_NAME || '');
  const [deleteCurrent, setDeleteCurrent] = useState(false);
  const [passingCriteria, setPassingCriteria] = useState('');
  const [reattempts, setReattempts] = useState('');
  const [assessmentStatus, setAssessmentStatus] = useState('Active');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    console.log(values)
    if (values?.adminScheduleAssessment && values?.adminScheduleAssessment?.length > 0) {
      setDeleteCurrent(true);
      // Set assessment details (assuming they are the same for all MCQs)
      const firstAssessment = values.adminScheduleAssessment[0];
      // setAssessmentName(firstAssessment.assessmentName);
      setPassingCriteria(firstAssessment.passingCriteria);
      setReattempts(firstAssessment.reattempts);
      setAssessmentStatus(firstAssessment.assessmentStatus);

      // Transform all assessments into MCQ objects
      const mcqsData = values.adminScheduleAssessment.map((assessment) => ({
        question: assessment.assessmentTitle, // Use the assessmentTitle as the question
        choices: assessment.assessmentOptions.map(option => option.assessmentOption), // Map options to choices
        correctAnswer: assessment.assessmentOptions.findIndex(option => option.answer === true), // Find the correct answer index
        id: assessment.ID, // Include the ID for reference
      }));

      // Set the MCQ state with the transformed data
      setMcqs(mcqsData);
    }
  }, [values]);

  // const handleAddMcq = () => {
  //   if (question.trim()) {
  //     const newMcq = { question, choices, correctAnswer };

  //     if (selectedMcqIndex !== null) {
  //       // Update existing MCQ
  //       const updatedMcqs = [...mcqs];
  //       updatedMcqs[selectedMcqIndex] = newMcq;
  //       setMcqs(updatedMcqs);
  //     } else {
  //       // Add new MCQ
  //       setMcqs([...mcqs, newMcq]);
  //     }

  //     // Reset form
  //     setQuestion('');
  //     setChoices(['', '']);
  //     setCorrectAnswer(null);
  //     setSelectedMcqIndex(null);
  //   }
  // };


  const handleAddMcq = () => {
    if (!question.trim()) {
      setErrorMessage('Please enter a question.');
      return;
    }

    if (choices.some(choice => !choice.trim())) {
      setErrorMessage('Please fill in all choices.');
      return;
    }

    if (correctAnswer === null) {
      setErrorMessage('Please select the correct answer.');
      return;
    }

    const newMcq = { question, choices, correctAnswer };

    if (selectedMcqIndex !== null) {
      const updatedMcqs = [...mcqs];
      updatedMcqs[selectedMcqIndex] = newMcq;
      setMcqs(updatedMcqs);
    } else {
      setMcqs([...mcqs, newMcq]);
    }

    setQuestion('');
    setChoices(['', '']);
    setCorrectAnswer(null);
    setSelectedMcqIndex(null);
    setErrorMessage('');
  };

  const handleNewMcq = () => {
    setSelectedMcqIndex(null);
    setQuestion('');
    setChoices(['', '']);
    setCorrectAnswer(null);
  };

  const handleSelectMcq = (index) => {
    setSelectedMcqIndex(index);
    setQuestion(mcqs[index].question);
    setChoices(mcqs[index].choices);
    setCorrectAnswer(mcqs[index].correctAnswer);
  };

  const handleRemoveMcq = (index) => {
    setMcqs(mcqs.filter((_, i) => i !== index));
    if (selectedMcqIndex === index) {
      setSelectedMcqIndex(null);
      setQuestion('');
      setChoices(['', '']);
      setCorrectAnswer(null);
    }
  };


  const { mutateAsync } = useTMutation("/addAdminSpecailtyAssessment", "post", (data) => data);

  const handleSave = async () => {
    if (mcqs.length === 0) {
      setErrorMessage('Please add at least one MCQ.');
      return;
    }

    const assessmentData = mcqs.map((mcq) => ({
      assessmentTitle: mcq.question,
      assessmentOptions: mcq.choices.map((choice, index) => ({
        assessmentOption: choice,
        answer: index === mcq.correctAnswer,
      })),
    }));

    const payload = {
      assessmentName,
      assessmentStatus,
      assessmentData,
      passingCriteria,
      reattempts,
      ID: values.ID,
      deleteCurrent,
    };

    // return  console.log("payload", payload);

    const response = await mutateAsync(payload);
    if (response.STATUS) {
      showToast("success", response.MESSAGE, 3000);
      navigate(`/admin/profile-criteria/fetchSpecialtyRoleMappings`);
    } else {
      showToast("error", response.MESSAGE, 3000);
    }
  };

  return (
    <Box sx={{ padding: 4, height: '100vh', bgcolor: '#f5f5f5' }}>
      {!values.REDIRECT && (
        <Button
          onClick={() => dispatch(previousStep())}
          startIcon={<ArrowBackIosIcon sx={{ fontSize: 12, color: '#000' }} />}
          sx={{ textTransform: 'none', fontWeight: 500, fontSize: 14, padding: 3 }}
        />
      )}

      <Grid container spacing={2} sx={{ height: '100%' }}>
        {/* Left - MCQ List */}
        <Grid item xs={3}>
          <Paper sx={{ height: '94%', p: 2 }}>
            <Typography variant="h6">Questions</Typography>
            <List>
              {mcqs.map((mcq, index) => (
                <ListItem button key={index} onClick={() => handleSelectMcq(index)}>
                  <Typography sx={{ mr: 1, fontWeight: 'bold', color: '#6ebe44' }}>
                    {index + 1}.
                  </Typography>
                  <ListItemText primary={mcq.question} />
                  <IconButton onClick={(e) => { e.stopPropagation(); handleRemoveMcq(index); }}>
                    <DeleteIcon sx={{ color: 'red' }} />
                  </IconButton>
                </ListItem>
              ))}
            </List>

            <Button sx={{ color: '#6ebe44', mt: 2 }} onClick={handleNewMcq} startIcon={<AddIcon />}>
              {'Add MCQ'}
            </Button>
          </Paper>
        </Grid>

        {/* Middle - MCQ Form */}
        <Grid item xs={6}>
          <Paper sx={{ height: '94%', p: 2 }}>
            <Typography variant="h6">Write your question here</Typography>
            <TextField
              fullWidth
              margin="normal"
              placeholder="Enter question"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />

            {/* {choices.map((choice, index) => (
              <TextField
                key={index}
                fullWidth
                margin="normal"
                placeholder={`Choice ${index + 1}`}
                value={choice}
                onChange={(e) => {
                  const newChoices = [...choices];
                  newChoices[index] = e.target.value;
                  setChoices(newChoices);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" sx={{ border: '1px solid #6ebe44', padding: '12px 8px' }}>
                      {String.fromCharCode(65 + index)}
                    </InputAdornment>
                  ),
                }}
              />
            ))} */}

          {choices?.map((choice, index) => (
            <TextField
              key={index}
              fullWidth
              margin="normal"
              placeholder={`Choice ${index + 1}`}
              value={choice}
              onChange={(e) => {
                const newChoices = [...choices];
                newChoices[index] = e.target.value;
                setChoices(newChoices);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ border: '1px solid #6ebe44', padding: '12px 8px' }}>
                    {String.fromCharCode(65 + index)}
                  </InputAdornment>
                ),
                endAdornment:
                  index >= 2 ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          const newChoices = choices.filter((_, i) => i !== index);
                          setChoices(newChoices);
                        }}
                      >
                        ❌
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              }}
            />
          ))}



            {/* Commented By Anuj 17/4/2025 */}
            {/* <Grid container justifyContent="start" spacing={2}>
              <Grid item>
                <Button
                  sx={{
                    color: '#6ebe44',
                    border: "1px solid #6ebe44",
                    '&:hover': {
                      backgroundColor: 'transparent',
                      color: '#6ebe44',
                    },
                  }} onClick={() => setChoices([...choices, ''])}>
                  Add choice
                </Button>

                <Button
                  sx={{
                    color: '#6ebe44',
                    border: "1px solid #6ebe44",
                    '&:hover': {
                      backgroundColor: 'transparent',
                      color: '#6ebe44',
                    },
                  }}
                  onClick={handleAddMcq}>
                  {selectedMcqIndex !== null ? 'Update MCQ' : 'Add MCQ'}
                </Button>

              </Grid>
            </Grid> */}

            <Grid container justifyContent="start" spacing={2}>
              <Grid item>
                <Button
                  sx={{
                    color: '#6ebe44',
                    border: "1px solid #6ebe44",
                    '&:hover': {
                      backgroundColor: 'transparent',
                      color: '#6ebe44',
                    },
                  }}
                  onClick={() => setChoices([...choices, ''])}
                >
                  Add choice
                </Button>
              </Grid>

              <Grid item>
                <Button
                  sx={{
                    color: '#6ebe44',
                    border: "1px solid #6ebe44",
                    '&:hover': {
                      backgroundColor: 'transparent',
                      color: '#6ebe44',
                    },
                  }}
                  onClick={handleAddMcq}
                >
                  {selectedMcqIndex !== null ? 'Update MCQ' : 'Add MCQ'}
                </Button>
              </Grid>
            </Grid>



            <Typography variant="h6" sx={{ mt: 2 }}>Select Correct Answer</Typography>
            <RadioGroup
              value={correctAnswer}
              onChange={(e) => {
                setCorrectAnswer(Number(e.target.value));
                if (selectedMcqIndex !== null) {
                  const updatedMcqs = [...mcqs];
                  updatedMcqs[selectedMcqIndex].correctAnswer = Number(e.target.value);
                  setMcqs(updatedMcqs);
                }
              }}
            >
              {choices.map((choice, index) => (
                <FormControlLabel
                  key={index}
                  value={index}
                  control={<Radio />}
                  label={choice}
                />
              ))}
            </RadioGroup>
            {errorMessage && (
              <Typography color="error" mt={2} textAlign="start">
                {errorMessage}
              </Typography>
            )}
          </Paper>
        </Grid>

        {/* Right - Settings */}
        <Grid item xs={3}>
          <Paper sx={{ height: '94%', p: 2 }}>
            <Typography variant="h6">Settings</Typography>
            <Divider sx={{ mb: 3 }} />
            <TextField
              label="Assessment Name"
              fullWidth
              variant="outlined"
              value={assessmentName}
              onChange={(e) => setAssessmentName(e.target.value)}
              sx={{ mb: 2 }}
              disabled
            />
            <TextField
              label="Specialty"
              fullWidth
              variant="outlined"
              value={specialityName}
              onChange={(e) => setSpecialtyName(e.target.value)}
              sx={{ mb: 2 }}
              disabled
            />
            <TextField
              label="Passing Criteria"
              fullWidth
              variant="outlined"
              value={passingCriteria}
              type="number"
              onChange={(e) => setPassingCriteria(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Number of Reattempts"
              fullWidth
              variant="outlined"
              type="number"
              value={reattempts}
              onChange={(e) => setReattempts(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Status"
              fullWidth
              variant="outlined"
              select
              value={assessmentStatus}
              onChange={(e) => setAssessmentStatus(e.target.value)}
              sx={{ mb: 2 }}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>
            <Stack spacing={2} direction="row" justifyContent="end" sx={{ mt: 3 }}>
              <Button variant="outlined" sx={{ border: '1px solid lightgrey', color: '#6ebe44' }} onClick={() => navigate(`/admin/profile-criteria/fetchSpecialtyRoleMappings`)}>
                Cancel
              </Button>
              <Button className="gradientAdminThemeColor" onClick={handleSave}>
                Save
              </Button>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default QuestionForm;